module.exports = __webpack_public_path__ + "img/cr.657d7dbc.svg";